import { Box, List, ListItem, ListItemIcon, ListItemText, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { IReportNotificationSummaryDTO } from "../../services/reporting-data-service/ReportScheduleModels";
import { Square } from "@mui/icons-material";

export type ScheduleNotificationsCardProps = {
    title: string,
    items: IReportNotificationSummaryDTO[],
    sx?: SxProps<Theme>; 
};

export function ScheduleNotificationsCard({
    title,
    items,
    sx
}: ScheduleNotificationsCardProps) {

    const theme = useTheme();

    return (
        <Box sx={{
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 6,
            marginRight: 1,
            padding: 1,
            paddingBottom: 0,
            ...sx
        }}>
            <Typography variant="body2"
                sx={{
                    color: theme.palette.grey[600],
                }}>
                {title}
            </Typography>
            <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'        
                    }}>

                        {items.sort((a, b) => (a.displayText ?? '').localeCompare(b.displayText ?? ''))?.map((o, index) =>


                        <ListItem key={index} disablePadding >

                        <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                            <Square fontSize="inherit"/>
                        </ListItemIcon>

                        <ListItemText 
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            primary={
                                o.displayText
                            } 

                            slotProps={{
                                primary: {
                                    component: 'div',
                                    sx: {
                                        fontSize: '.9rem',
                                        display: 'flex',
                                        color: theme.palette.grey[600]
                                    }
                                }
                            }} 
                        />

                        </ListItem>  


                        )}                                      
                    </List>
        </Box>
    );
}
